<template>
  <div class="homeFunFact">
    <div class="auto-container">
      <div class="fact-counter">
        <div class="row clearfix flex flex-wrap w-full">
          <!-- Counter Box -->
          <CounterBox :value="5000" :speed="3000" :label="fc_getText(null, 'funFact_utilizadores')" />
          <CounterBox :value="20" :speed="3000" :label="fc_getText(null, 'funFact_experiencia')" />
          <CounterBox :value="1000000" :speed="3000" :label="fc_getText(null, 'funFact_processos')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CounterBox from './CounterBox.vue';
export default {
  components: {
    CounterBox
  },
  data() {
    return {
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<style scoped>
  .homeFunFact {
    position: relative;
    display: block;
    padding: 160px 0 110px;
    background-image: url("@/assets/icons/bg-3.png");
    background-position: 100% center;
    background-repeat: no-repeat;
  }
  .homeFunFact:before {
    position: absolute;
    left: 0;
    top: 120px;
    width: 971px;
    height: 680px;
    content: "";
    background-image: url("@/assets/icons/bg-5.png");
    background-position: left;
    background-repeat: no-repeat;
    z-index: -1;
  }
  .homeFunFact .fact-counter {
    position: relative;
    padding-left: 70px;
  }
  .homeFunFact .counter-box {
    position: relative;
    margin-bottom: 50px;
  }
  .homeFunFact .counter-box .inner-box {
    position: relative;
    text-align: center;
  }
  @media only screen and (max-width: 767px) {
      .homeFunFact {
          padding-top: 70px;
          padding-bottom: 0;
          background: none;
      }
  }
  @media only screen and (max-width: 1023px) {
      .homeFunFact .fact-counter {
          padding-left: 0;
      }
  }
</style>
